import React from 'react';
import { Modal, Box, Typography, Button, Dialog, DialogTitle, DialogContent, DialogActions, TextField } from '@mui/material';
import GetAppIcon from '@mui/icons-material/GetApp';
import downloadCatelougImage from '../../../../assets/images/download-cate.png';
import xlsxIcon from '../../../../assets/images/xlxs.png';
import downloadcaticon from '../../../../assets/images/download-btn-cat.png';
import CloseIcon from '@mui/icons-material/Close'; // Import Close icon

import { styled } from '@mui/system';


const CustomDialogTitle = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  marginBottom: theme.spacing(2),
}));
// Your modal's style
const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 4,
  borderRadius: 2
};
const modalStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: { xs: '90%', sm: '400px' }, // Responsive width  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 0,
  borderRadius: 2,
  bgcolor: 'background.paper',
};
const Image = styled('img')(({ theme }) => ({
  // borderRadius: '10px',
  // margin: theme.spacing(1),
  width: '400px',
  height: '150px',
  borderRadius: '8px'
}));

const modalTitleStyle = {
  width: '400px',
  height: '150px',
  borderRadius: '8px'
}
const FlexItem = styled(Box)({
  flex: 1, // This ensures each child takes equal space
  display: 'flex',
  justifyContent: 'center', // Centers children horizontally in the flex item
  alignItems: 'center', // Centers children vertically in the flex item
  flexDirection: 'column', // Stacks children vertically inside the flex item
  textAlign: 'center', // Centers text for Typography component
});
const DownloadButton = styled(Button)(({ theme }) => ({
  margin: theme.spacing(1),
}));
function DownloadCatelougeModal({ open, handleClose }) {
  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={modalStyle}>

        <DialogTitle sx={{ m: 0, p: "0px 1px 0px 1px", width: 'cover' }} id="modal-modal-title">
          {/* Modal title */}
          <Button
            onClick={handleClose}
            sx={{ 
              position: 'absolute', 
              right: 8, 
              top: 8, 
              minWidth: 0, // Remove the button's minimum width
              padding: '6px', // Reduce padding to shrink the button size
              color: 'gray', // Optional: change the color to match your design
            }}
          >
            <CloseIcon />
          </Button>
          <div>
            <Image src={downloadCatelougImage} alt="Download Catalogue" />
            <h4 className='headingForDeclineShipmentModal'>Download Company & Product Catalogue </h4>
          </div>
        </DialogTitle>
        <DialogContent  dividers>
          <Typography sx={{ fontFamily: 'Lato, sans-serif' }}>
            Download the company & product catalogue to check if your supplier and product details are already registered with us. If you do not see your supplier details in the catalogue, please advise your supplier to register with us. If you do not see your product details in the catalogue, please write to us at greentrack@adityabirla.com.
          </Typography>
         
          
          
        </DialogContent>
        <DialogActions  sx={{  flexDirection: { xs: 'column', sm: 'column' } }}>
        <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, alignItems: 'center', justifyContent: 'center' }}>
            <FlexItem>
              <img className='m-2' src={xlsxIcon} alt="XLSX Icon" />
            </FlexItem>
            <FlexItem>
              <Typography variant="body1">OrderCompanyCatalogue.xlsx</Typography>
            </FlexItem>
            <FlexItem>
              <DownloadButton
                // variant="contained"
                sx={{height:'15px'}}
                startIcon={
                  <img src={downloadcaticon} alt="Download" />
                }
                // href='src/pages/Orders/Outbox/Modals/OrderCompanyCatalogue.xlsx'
                href={`${process.env.PUBLIC_URL}/OrderCompanyCatalogue.xlsx`}
                download="OrderCompanyCatalogue.xlsx"
              >
                {/* Download */}
              </DownloadButton>
            </FlexItem>
            
          </Box>
        <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, alignItems: 'center', justifyContent: 'center' , }}>
            <FlexItem>
              <img className='m-2' src={xlsxIcon} alt="XLSX Icon" />
            </FlexItem>
            <FlexItem>
              <Typography variant="body1">OrderProductCatalogue.xlsx</Typography>
            </FlexItem>
            <FlexItem>
              <DownloadButton
                // variant="contained"
                sx={{height:'15px'}}

                startIcon={
                  <img src={downloadcaticon} alt="Download" />
                }
                // href='src/pages/Orders/Outbox/Modals/OrderCompanyCatalogue.xlsx'
                href={`${process.env.PUBLIC_URL}/OrderCompanyCatalogue.xlsx`}
                download="OrderCompanyCatalogue.xlsx"
              >
                {/* Download */}
              </DownloadButton>
            </FlexItem>
            
          </Box>
        </DialogActions>
      </Box>
    </Modal>
  );
}

export default DownloadCatelougeModal;
